module.exports = __webpack_public_path__ + "img/find-org-admin.c1bd3936.png";